export function Login() {
  window.location.href = `${process.env.REACT_APP_AUTH_URL}/select-profile`;
  return null;
}

export default Login;
